export default __webpack_public_path__ + "static/media/c-web.03b27721.jpg";